import React, { FC } from 'react'
import './hero-topic-front.module.scss'
import { sanitizeHTML } from '../../../../utils/common-utils'
import { getFacetImagePath, getValueListBgColor } from '../../../../utils/background-util'
import { HeroTopicFrontProps } from './HeroTopicFront.types'

export const HeroTopicFront: FC<HeroTopicFrontProps> = props => {
  const { content, testId } = props
  const {
    heading,
    body,
    image,
    textAlignment,
    color,
    buttonAlignment,
    buttonHref,
    buttonTarget,
    buttonText,
    buttonLinkAltText,
    analytics,
    noClip,
    brandExtension,
    fontColor,
  } = content

  const largeFacet = getFacetImagePath(color, { isMobile: false })
  const mobileFacet = getFacetImagePath(color, { isMobile: true })

  const bgClassName = getValueListBgColor(color ?? '')

  return (
    <section
      className={`HeroTopicFront--redesign ${brandExtension} u-paddingBottom8`}
      data-analytics-container='Hero'
      data-analytics-component-template='Topic Front'
      data-analytics-component-name='Hero - Redesign'
    >
      <div className='u-posRelative'>
        <img
          className={`HeroTopicFront-bgImage${
            noClip ? ' HeroTopicFront-bgImage--noClip' : ''
          } u-posAbsolute u-sm-hidden`}
          src={largeFacet}
          alt=''
          data-testid={testId ? `${testId}-facet` : null}
        />
        <img
          className={`HeroTopicFront-bgImage ${
            noClip ? ' HeroTopicFront-bgImage--noClip' : ''
          } u-posAbsolute u-md-hidden u-lg-hidden`}
          src={mobileFacet}
          alt=''
          data-testid={testId ? `${testId}-mobile-facet` : null}
        />
        <div
          className={
            'HeroTopicFront-contentBox u-flex u-sizeConstrained u-posRelative u-paddingHoriz48 u-paddingVert48'
          }
        >
          <div
            className={`u-lg-size1of2 u-md-size1of2 u-sm-sizeFill Content u-flex u-flexAlignItemsCenter ${textAlignment} ${bgClassName}`}
            data-testid={testId ? `${testId}-box` : null}
          >
            <div className='u-paddingHoriz20 u-paddingVert32'>
              <h1
                className={`Type-1 ${fontColor}`}
                data-testid={testId ? `${testId}-heading` : null}
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(heading ?? '') }}
              ></h1>
              <div
                className={`Content u-marginTop8 ${textAlignment} ${fontColor}`}
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(body ?? '') }}
                data-testid={testId ? `${testId}-body` : null}
              />
              {buttonText && (
                <a
                  className={`Button Button--primary Button--reversed u-marginTop24 ${buttonAlignment}`}
                  href={buttonHref}
                  target={buttonTarget}
                  aria-label={buttonLinkAltText || ''}
                  data-analytics={analytics}
                >
                  {buttonText}
                </a>
              )}
            </div>
          </div>
          <div className='HeroTopicFront-contentImage u-sm-hidden u-md-size2of3 u-lg-size2of3 u-posRelative'>
            <img
              className='u-sizeFull'
              src={image}
              alt=''
              data-testid={testId ? `${testId}-image` : null}
            />
          </div>
        </div>
      </div>
    </section>
  )
}
